// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29iv9","footer":"styles_footer__3uNcI"};